import { render, staticRenderFns } from "./TrComicsV2.vue?vue&type=template&id=e29eeae2&scoped=true&"
import script from "./TrComicsV2.vue?vue&type=script&lang=js&"
export * from "./TrComicsV2.vue?vue&type=script&lang=js&"
import style0 from "./TrComicsV2.vue?vue&type=style&index=0&id=e29eeae2&lang=scss&scoped=true&"
import style1 from "./TrComicsV2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29eeae2",
  null
  
)

export default component.exports